import * as React from 'react';
import { useQuery } from 'convex/react';
import { api } from '@/convex/_generated/api';
import { cn } from '@/lib/utils';

function getEnvironmentInfo() {
	const convexUrl = import.meta.env.VITE_CONVEX_URL || '';
	const isDev = convexUrl.includes('steady-viper-971');
	return {
		isDev,
		indicator: isDev ? '🔥' : '⚡️',
	};
}

export function VersionPill() {
	const version = useQuery(api.systemInfo.getVersion);
	const { indicator } = getEnvironmentInfo();

	if (!version) return null;

	return (
		<div
			className={cn(
				'fixed bottom-3 right-3 z-[99]',
				'px-4 py-2 rounded-full',
				'bg-white/50 dark:bg-black/10 backdrop-blur-sm',
				'text-xs text-gray-900 dark:text-white/80',
				'shadow-sm border border-border/50',
				'font-mono',
				'flex items-center gap-2'
			)}
		>
			<span>{indicator}</span>
			<span>v{version.value}</span>
		</div>
	);
}
